/**
 * Dispatch after learner actions that may award XP or unlock achievements.
 * ScoreNotifProvider listens and shows notifications when toasts are idle.
 */

export const GAMIFICATION_AFTER_ACTION = 'gamification:after-action';
/** Ask ScoreNotifProvider to scan for un-notified earned achievements (e.g. after dashboard load). */
export const GAMIFICATION_CHECK_ACHIEVEMENTS = 'gamification:check-achievements';

/** Fired when the learner SPA navigates to a non-admin view (lesson, profile, courses, etc.). */
export const GAMIFICATION_LEARNER_VIEW = 'gamification:learner-view';

export function notifyLearnerViewChange(view: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(GAMIFICATION_LEARNER_VIEW, { detail: { view } }));
}

export interface GamificationAfterActionDetail {
  /** XP granted by the API for this action (omit when unknown). */
  xpEarned?: number;
}

export function notifyGamificationAfterAction(detail: GamificationAfterActionDetail = {}): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<GamificationAfterActionDetail>(GAMIFICATION_AFTER_ACTION, { detail })
  );
}

export function requestAchievementNotifCheck(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(GAMIFICATION_CHECK_ACHIEVEMENTS));
}

/** Read isNew from achievement progress rows (camelCase or PascalCase). */
export function isAchievementNew(item: {
  isNew?: boolean;
  IsNew?: boolean;
  isEarned?: boolean;
  IsEarned?: boolean;
}): boolean {
  const earned = item.isEarned === true || item.IsEarned === true;
  const isNew = item.isNew === true || item.IsNew === true;
  return earned && isNew;
}

export function readXpAwarded(result: {
  xpAwarded?: number;
  XpAwarded?: number;
} | null | undefined): number {
  if (!result) return 0;
  const n = result.xpAwarded ?? result.XpAwarded ?? 0;
  return typeof n === 'number' && n > 0 ? n : 0;
}
